import React from "react";
import { ProgressBar } from "../ProgressBar/ProgressBar";

const DUMMY_DATA: ChartData[] = [
  { label: "SOFT SKILLS SCORE", value: 30 },
  { label: "HARD SKILLS SCORE", value: 100 },
  { label: "ability SCORE", value: 83 },
  { label: "interview Score", value: 58 },
];

type ChartData = {
  label: string;
  value: number;
};

type ScoreBarChartProps = {
  chartData: ChartData[];
};

const ScoreBarChart: React.FC<ScoreBarChartProps> = ({ chartData }) => {
  return (
    <div className="ScoreBarChart">
      {chartData.map((item, index) => (
        <div className="ScoreItem" key={"Score_Item_" + index}>
          <h4>{item.label.toUpperCase()}</h4>
          {/* Progress Bar is 0 - 100, so multiply scores from endpoint (0-10) by 10 */}
          <ProgressBar percentageComplete={item.value * 10} />
        </div>
      ))}
    </div>
  );
};

export default ScoreBarChart;
